module.exports = __webpack_public_path__ + "img/google-chrome-logo.f7e6c9d9.svg";